export default "__VITE_ASSET__PrSfJ$P$__"